import { v3Url } from '@/utils/fetcher';
import { useAxios } from '../base/useAxios';

export default function useCalendarEventsPlanningPermissionsActions() {
  const api = useAxios();

  return {
    enableCalendarEventsPlanning({ calendar }) {
      return api.post(v3Url(`calendars/permission`), { calendar });
    },
    disableCalendarEventsPlanning({ type }) {
      return api.delete(v3Url(`calendars/permission/${type}`));
    },
  };
}
